<div class="top-section">
    <h3>
        Ro-Ro/PCTC Trade & Port Intelligence
    </h3>
</div>

<section class="rate-request rate-request-sec">
  <div class="middle-section">
      <div class="container">
          <div class="rate-request-form">
              <div class="rate-request-form-inner">
                Select Region
                  <div class="pRel">
                      <p-dropdown [options]="regions" optionLabel="regionName" [(ngModel)]="selectedRegion"
                          (onChange)="onChangeRegion()" placeholder="Region" [virtualScroll]="true" [filter]="false"
                          class="p-dropdown">
                      </p-dropdown>
                      <span class="downArrow"><img src="../../../../../assets/images/arrow.png" /></span>
                  </div>
            </div>
            </div>
      </div>
  </div>
</section>

  <section class="tabs-details">
    <div class="container">
      <div class="tabs-details-inner">
        <div class="tab-item">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home"
                aria-selected="true" (click)='getTabDetails(region)'>Region</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" *ngIf="isPermission != true" id="profile-tab" aria-disabled="true" data-toggle="tab"
                href="#profile" role="tab" aria-controls="profile" aria-selected="false"
                (click)='getTabDetails(port)'>Port</a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" *ngIf="isPermission != true" id="contact-tab" data-toggle="tab" href="#contact"
                role="tab" aria-controls="contact" aria-selected="false" (click)='gettabDetails(cheapest)'>Cheapest</a>
            </li> -->
          </ul>
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="home-tab" data-toggle="tab" role="tab" aria-controls="home"
                aria-selected="true" (click)='getSchedulerRouting(0)'>Import</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="home-tab" data-toggle="tab" role="tab" aria-controls="home" aria-selected="true"
                (click)='getSchedulerRouting(1)'>Export</a>
            </li>
          </ul>
        </div>
  
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
            <div class="container">
              <div class="row">
                <div class="col-lg-3">
                  <div class="filter-sec">
                    <p-accordion>
                      <p-accordionTab header="Shipping Lines" [selected]="true">
                        <div class="shipping-sec">
                          <div class="shipping-lines">
                            <div class="select-section-relative">
                              <p-multiSelect [options]="shippingLines" [(ngModel)]="selectedShipLines"
                                optionLabel="shippingLineName" [virtualScroll]="true" [filter]="false"
                                (onChange)="getSelectedShippingLine($event)">
                              </p-multiSelect>
                            </div>
                            <div class="box-sec-outer" style="display: block;margin-top: 5px;">
                              <ul class="list-group border-0">
                                <li class="list-group-item d-flex justify-content-between align-items-center border-0"
                                  style="padding: 0.3rem 0.25rem;" *ngFor="let ship of selectedShipLines; let i = index;">
                                  {{ship.shippingLineName}}
                                  <span class="badge badge-secondary badge-pill" (click)='removeShips(ship)'
                                    style="cursor: pointer;">
                                    x
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </p-accordionTab>
                      <!-- <p-accordionTab header="Region" [selected]="true">
                        <div class="shipping-sec">
                          <div class="shipping-lines">
                            <div class="select-section-relative">
                              <p-multiSelect [options]="regions" [(ngModel)]="selectedRegion"
                                optionLabel="regionName" [virtualScroll]="true" [filter]="false"
                                (onChange)="getSelectedRegion($event)">
                              </p-multiSelect>
                            </div>
                            <div class="box-sec-outer" style="display: block;margin-top: 5px;">
                              <ul class="list-group border-0">
                                <li class="list-group-item d-flex justify-content-between align-items-center border-0"
                                  style="padding: 0.3rem 0.25rem;" *ngFor="let region of selectedRegion; let i = index;">
                                  {{region.regionName}}
                                  <span class="badge badge-secondary badge-pill" (click)='removeShips(ship)'
                                    style="cursor: pointer;">
                                    x
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </p-accordionTab> -->
                      
                      <p-accordionTab header="Times">
                        <section class="timer-sec">
                          <div class="departure-sec">
                            <h4>Departure {{departurePortName}}</h4>
                            <div class="departure-sec-inner">
                              <div class="time-image" *ngIf="IsFilter">
                                <ng5-slider [(value)]="valueArrival" [options]="arroption"
                                  (userChangeEnd)="fromPortChangeSlidder($event)">
                                </ng5-slider>
                              </div>
                            </div>
                          </div>
                          <div class="departure-sec">
                            <h4>Arrival {{arrivalPortName}}</h4>
                            <div class="departure-sec-inner">
                              <div class="time-image" *ngIf="IsFilter">
                                <ng5-slider [(value)]="valueDep" [options]="OptionsDep"
                                  (userChangeEnd)="toPortChangeSlidder($event)">
                                </ng5-slider>
                              </div>
                            </div>
                          </div>
                        </section>
                      </p-accordionTab>
                      <p-accordionTab header="Transhipment Ports" *ngIf="transhipmentPorts.length > 0">
                        <section class="timer-sec">
                          <div class="departure-sec">
                            <p-dropdown [options]="transhipmentPorts" [(ngModel)]="selectedTranshipmentPort"
                              optionLabel="portName" class="select-dropdown-sec" placeholder="Select Port"
                              [virtualScroll]="true" (onChange)="filterByTranshipmentPorts($event)" [itemSize]="5"
                              [filter]="false"></p-dropdown>
                          </div>
                        </section>
                      </p-accordionTab>
                    </p-accordion>
                  </div>
                  <div class="serachresultfiter filter-sec mt-1">ENL Solutions is not responsible for the accuracy of the
                    information.The information can be changed by the
                    shipping line at any time and without any notice
                  </div>
  
                </div>
                <div class="col-lg-9">
                  <div class="table-sec">
                    <div class="table-responsive">
                      <!-- <table class="table"> -->
                      <p-table class="table" [value]="searchResult" *ngIf="totalCount > 0">
                        <ng-template pTemplate="body" let-result>
                          <tr class="tdvm" class="tdvm" tooltipPosition="top" *ngIf="result.isTranshipment == 1">
                            <td>
                              <div class="flexdiv">
                                <div pTooltip="Vessels Name: {{result.vesselsName}}">
                                  <img class="image1" src="{{result.companyLogo}}">
                                  <h4>{{result.fromPortName}}</h4>
                                  <div class="date-info">Dep: {{result.fromPortArrivalDate | date: 'dd-MM-yyyy'}} </div>
                                </div>
                                <div>
                                  <div class="text-direct"> Transhipment </div>
                                </div>
                                <div pTooltip="Vessels: {{result.toVesselsName}}">
                                  <img class="image1" src="{{result.toCompanyLogo}}">
                                  <h4>{{result.midPortName}}</h4>
                                  <div class="date-info"><strong>Arr:
                                      {{result.midPortArrivalDate | date: 'dd-MM-yyyy'}}</strong> </div>
                                  <div class="date-info"><strong>Dep:
                                      {{result.midPortDepartureDate | date: 'dd-MM-yyyy'}}</strong> </div>
                                </div>
                                <div>
                                  <div class="text-direct "> Transhipment </div>
                                </div>
                                <div pTooltip="Vessel: {{result.toVesselsName}}">
                                  <h4>{{result.toPortName}}</h4>
                                  <div class="date-info"><strong>Arr:
                                      {{result.toPortArrivalDate | date: 'dd-MM-yyyy'}}</strong></div>
                                </div>
                                <div>
                                  <button class="btn btn-outline-success btn-details my-2 mb-1 rate-request" type="submit"
                                    (click)="getRateRequest(result.shippingLineId)">Rate Request</button>
                                  <button class="btn btn-outline-success btn-details my-2 my-sm-0 rate-request"
                                    type="submit"
                                    (click)="getTranshipmentVoyage(result.vesselsId,result.toVesselsId,result.midPortId,result.fromPortArrivalDate,result.toPortArrivalDate)">DETAILS</button>
                                  <button class="btn btn-outline-success btn-details my-2 my-sm-0 rate-request"
                                    (click)="tracking(result.shippingLineId,result.vesselsId,result.fromPortArrivalDate,result.isTranshipment)">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                      <path
                                        d="M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z" />
                                      <path d="M0 0h24v24H0z" fill="none" /></svg>
                                    Track</button>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr class="tdvm" pTooltip="Vessel: {{result.vesselsName}}" tooltipPosition="top"
                            *ngIf="result.isTranshipment == 0">
                            <td>
                              <div class="flexdiv">
                                <div> <img class="image1" src="{{result.companyLogo}}"> </div>
                                <div>
                                  <h4>{{result.fromPortName}}</h4>
                                  <div class="date-info"> {{result.fromPortArrivalDate | date: 'dd-MM-yyyy'}} </div>
                                </div>
                                <div>
                                  <div class="text-direct"> Direct </div>
                                </div>
                                <div>
                                  <h4>{{result.toPortName}}</h4>
                                  <div class="date-info"> {{result.toPortArrivalDate | date: 'dd-MM-yyyy'}}</div>
                                </div>
                                <div>
                                  <button class="btn btn-outline-success btn-details my-2 my-sm-0 rate-request"
                                    type="submit" (click)="getRateRequest(result.shippingLineId)">Rate Request</button>
                                  <button class="btn btn-outline-success btn-details my-2 my-sm-0 rate-request"
                                    type="submit"
                                    (click)="getDetails(result.vesselsId,result.fromPortArrivalDate,result.toPortArrivalDate)">DETAILS</button>
  
                                  <button class="btn btn-outline-success btn-details my-2 my-sm-0 rate-request"
                                    (click)="tracking(result.shippingLineId,result.vesselsId,result.fromPortArrivalDate,result.isTranshipment)">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                      <path
                                        d="M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z" />
                                      <path d="M0 0h24v24H0z" fill="none" /></svg>
                                    Track</button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </ng-template>
                        <!-- </table> -->
                      </p-table>
                      <div *ngIf="totalCount == 0">
                        <span *ngIf="scheduleRroute == 0">No direct sailings found. Please check transhipment options by
                          clicking on "Transhipment" above.</span>
                        <span *ngIf="scheduleRroute == 1">No records found</span>
                      </div>
                    </div>
  
                  </div>
                  <div class="pageBox mt-4">
                    <p-paginator *ngIf="totalCount > 0" [rows]="pageSize" [rowsPerPageOptions]="[5,10,20]"
                      [totalRecords]="totalCount" (onPageChange)="paginate($event)" #p></p-paginator>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
            <div class="container">
              <div class="row">
                <div class="col-lg-3">
                  <div class="filter-sec">
                    <p-accordion>
                      <p-accordionTab header="Shipping Lines" [selected]="true">
                        <div class="shipping-sec">
                          <div class="shipping-lines">
                            <h4>
                              Shipping Lines
                            </h4>
                            <div class="select-section-relative">
                              <p-multiSelect [options]="shippingLines" [(ngModel)]="selectedShipLines"
                                optionLabel="shippingLineName" [virtualScroll]="true" [filter]="false"
                                (onChange)="getSelectedShippingLine($event)">
                              </p-multiSelect>
                            </div>
                            <div class="box-sec-outer" style="display: block;margin-top: 5px;">
                              <ul class="list-group border-0">
                                <li class="list-group-item d-flex justify-content-between align-items-center border-0"
                                  style="padding: 0.3rem 0.25rem;" *ngFor="let ship of selectedShipLines; let i = index;">
                                  {{ship.shippingLineName}}
                                  <span class="badge badge-secondary badge-pill" (click)='removeShips(ship)'
                                    style="cursor: pointer;">
                                    x
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </p-accordionTab>
                      <p-accordionTab header="Times">
                        <section class="timer-sec">
                          <div class="departure-sec">
                            <h4>Departure {{departurePortName}}</h4>
                            <div class="departure-sec-inner">
                              <div class="time-image" *ngIf="IsFilter">
                                <ng5-slider [(value)]="valueArrival" [options]="arroption"
                                  (userChangeEnd)="fromPortChangeSlidder($event)">
                                </ng5-slider>
                              </div>
                            </div>
                          </div>
                          <div class="departure-sec">
                            <h4>Arrival {{arrivalPortName}}</h4>
                            <div class="departure-sec-inner">
                              <div class="time-image" *ngIf="IsFilter">
                                <ng5-slider [(value)]="valueDep" [options]="OptionsDep"
                                  (userChangeEnd)="toPortChangeSlidder($event)">
                                </ng5-slider>
                              </div>
                            </div>
                          </div>
                        </section>
                      </p-accordionTab>
                      <p-accordionTab header="Transhipment Ports" *ngIf="transhipmentPorts.length > 0">
                        <section class="timer-sec">
                          <div class="departure-sec">
                            <p-dropdown [options]="transhipmentPorts" [(ngModel)]="selectedTranshipmentPort"
                              optionLabel="portName" class="select-dropdown-sec" placeholder="Select Port"
                              [virtualScroll]="true" (onChange)="filterByTranshipmentPorts($event)" [itemSize]="5"
                              [filter]="false"></p-dropdown>
                          </div>
                        </section>
                      </p-accordionTab>
                    </p-accordion>
                  </div>
                  <div class="serachresultfiter filter-sec mt-1">ENL Solutions is not responsible for the accuracy of the
                    information.The information can be changed by the
                    shipping line at any time and without any notice
                  </div>
                </div>
                <div class="col-lg-9">
                  <div class="table-sec">
                    <div class="table-responsive">
                      <p-table [value]="Quickestserchres" *ngIf="totalCount > 0">
                        <ng-template pTemplate="body" let-quickdet>
                          <tr *ngIf="quickdet.isTranshipment == 1">
                            <td tooltipPosition="top" class="second-child"
                              pTooltip="Vessel: {{quickdet.vesselsName}} &#xA; Dep.: {{quickdet.fromPortName}} &#xA; Dep. Date: {{quickdet.fromPortDepartureDate}} &#xA; Arr.: {{quickdet.midPortName}} &#xA; Arr. Date: {{quickdet.midPortDepartureDate}}">
                              <img src="{{quickdet.LogoUrl}}" class="image1">
                            </td>
                            <td class="second-child" tooltipPosition="top"
                              pTooltip="Vessel: {{quickdet.toVesselsName}} &#xA; Dep.: {{quickdet.midPortName}} &#xA; Dep. Date: {{quickdet.midPortDepartureDate}} &#xA; Arr.: {{quickdet.toPortName}} &#xA; Arr. Date: {{quickdet.toPortArrivalDate}}">
                              <img src="{{quickdet.toCompanyLogo}}" class="image1">
                            </td>
                            <td class="transipment-chart">
                              <p-chart type="horizontalBar" [data]="quickdet.quickestdata" [options]="optionsquick"
                                [responsive]="true" height="100px" width="185px"></p-chart>
                            </td>
                            <td class="second-child-button">
                              <button class="btn btn-outline-success btn-details my-2 my-sm-0 rate-request" type="submit"
                                (click)="getRateRequest(quickdet.shippingLineId)">Rate Request</button>
                              <button class="btn btn-outline-success btn-details my-1 my-sm-0 rate-request" type="submit"
                                (click)="getTranshipmentVoyage(quickdet.vesselsId,quickdet.toVesselsId,quickdet.midPortId,quickdet.fromPortDepartureDate,quickdet.toPortArrivalDate)">DETAILS</button>
  
                              <button class="btn btn-outline-success btn-details smy-2 my-sm-0 rate-request"
                                (click)="tracking(quickdet.shippingLineId,quickdet.vesselsId,quickdet.fromPortDepartureDate,quickdet.isTranshipment)">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                  <path
                                    d="M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z" />
                                  <path d="M0 0h24v24H0z" fill="none" /></svg>
                                Track</button>
                            </td>
                          </tr>
                          <tr *ngIf="quickdet.isTranshipment == 0">
                            <td tooltipPosition="top" class="second-child"
                              pTooltip="Vessel: {{quickdet.vesselsName}} &#xA; Dep.: {{quickdet.fromPortName}} &#xA; Dep. Date: {{quickdet.fromPortDepartureDate}} &#xA; Arr.: {{quickdet.toPortName}} &#xA; Arr. Date: {{quickdet.toPortArrivalDate}}">
                              <img src="{{quickdet.LogoUrl}}" class="image1">
                            </td>
                            <td class="direct-chart">
                              <p-chart type="horizontalBar" [data]="quickdet.quickestdata" [options]="optionsquick"
                                [responsive]="true" height="100px" width="255px"></p-chart>
                            </td>
                            <td class="second-child-button">
                              <button class="btn btn-outline-success btn-details my-2 my-sm-0 rate-request" type="submit"
                                (click)="getRateRequest(quickdet.shippingLineId)">Rate Request</button>
                              <button class="btn btn-outline-success btn-details my-1 my-sm-0 rate-request" type="submit"
                                (click)="getDetails(quickdet.vesselsId,quickdet.fromPortDepartureDate,quickdet.toPortArrivalDate)">DETAILS</button>
                              <button class="btn btn-outline-success btn-details my-2 my-sm-0 rate-request"
                                (click)="tracking(quickdet.shippingLineId,quickdet.vesselsId,quickdet.fromPortDepartureDate,quickdet.isTranshipment)">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                  <path
                                    d="M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z" />
                                  <path d="M0 0h24v24H0z" fill="none" /></svg>
                                Track </button>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                      <div *ngIf="totalCount == 0">
                        <span>No records found</span>
                      </div>
                    </div>
                  </div>
                  <div class="pageBox mt-4">
                    <p-paginator *ngIf="totalCount > 0" [rows]="pageSize" [rowsPerPageOptions]="[5,10,20]"
                      [totalRecords]="totalCount" (onPageChange)="paginatePort($event)" #p></p-paginator>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
            <div class="container">
              <div class="row">
                <div class="col-lg-3">
                  <div class="filter-sec">
                    <p-accordion>
                      <p-accordionTab header="Shipping Lines" [selected]="true">
                        <div class="shipping-sec">
                          <div class="shipping-lines">
                            <h4>
                              Shipping Lines
                            </h4>
                            <div class="select-section-relative">
                              <p-multiSelect [options]="shippingLines" [(ngModel)]="selectedShipLines"
                                optionLabel="shippingLineName" [virtualScroll]="true" [filter]="false"
                                (onChange)="getSelectedShippingLine($event)">
                              </p-multiSelect>
                            </div>
                            <div class="box-sec-outer" style="display: block;margin-top: 5px;">
                              <ul class="list-group border-0">
                                <li class="list-group-item d-flex justify-content-between align-items-center border-0"
                                  style="padding: 0.3rem 0.25rem;" *ngFor="let ship of selectedShipLines; let i = index;">
                                  {{ship.shippingLineName}}
                                  <span class="badge badge-secondary badge-pill" (click)='removeShips(ship)'
                                    style="cursor: pointer;">
                                    x
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </p-accordionTab>
                      <p-accordionTab header="Times">
                        <section class="timer-sec">
                          <div class="departure-sec">
                            <h4>Departure {{departurePortName}}</h4>
                            <div class="departure-sec-inner">
                              <div class="time-image" *ngIf="IsFilter">
                                <ng5-slider [(value)]="valueArrival" [options]="arroption"
                                  (userChangeEnd)="fromPortChangeSlidder($event)">
                                </ng5-slider>
                              </div>
                            </div>
                          </div>
                          <div class="departure-sec">
                            <h4>Arrival {{arrivalPortName}}</h4>
                            <div class="departure-sec-inner">
                              <div class="time-image" *ngIf="IsFilter">
                                <ng5-slider [(value)]="valueDep" [options]="OptionsDep"
                                  (userChangeEnd)="toPortChangeSlidder($event)">
                                </ng5-slider>
                              </div>
                            </div>
                          </div>
                        </section>
                      </p-accordionTab>
                      <p-accordionTab header="Transhipment Ports" *ngIf="transhipmentPorts.length > 0">
                        <section class="timer-sec">
                          <div class="departure-sec">
                            <p-dropdown [options]="transhipmentPorts" [(ngModel)]="selectedTranshipmentPort"
                              optionLabel="portName" class="select-dropdown-sec" placeholder="Select Port"
                              [virtualScroll]="true" (onChange)="filterByTranshipmentPorts($event)" [itemSize]="5"
                              [filter]="false"></p-dropdown>
                          </div>
                        </section>
                      </p-accordionTab>
                    </p-accordion>
                  </div>
                  <div class="serachresultfiter filter-sec mt-1">ENL Solutions is not responsible for the accuracy of the
                    information.The information can be changed by the
                    shipping line at any time and without any notice
                  </div>
                </div>
                <div class="col-lg-9">
                  <div class="table-sec">
                    <div class="table-responsive">
                      <p-table [value]="chepestserchres" *ngIf="totalCount > 0">
                        <ng-template pTemplate="body" let-quickdet>
                          <tr *ngIf="quickdet.isTranshipment == 1">
                            <td tooltipPosition="top"
                              pTooltip="Vessel: {{quickdet.vesselsName}} &#xA; Dep.: {{quickdet.fromPortName}} &#xA; Dep. Date: {{quickdet.fromPortDepartureDate}} &#xA; Arr.: {{quickdet.midPortName}} &#xA; Arr. Date: {{quickdet.midPortArrivalDate}}">
                              <img src="{{quickdet.LogoUrl}}" class="image1">
                            </td>
                            <td class="second-child" tooltipPosition="top"
                              pTooltip="Vessel: {{quickdet.toVesselsName}} &#xA; Dep.: {{quickdet.midPortName}} &#xA; Dep. Date: {{quickdet.midPortDepartureDate}} &#xA; Arr.: {{quickdet.toPortName}} &#xA; Arr. Date: {{quickdet.toPortArrivalDate}}">
                              <img src="{{quickdet.toCompanyLogo}}" class="image1">
                            </td>
                            <td>
                              <p-chart type="horizontalBar" [data]="quickdet.quickestdata" [options]="optionsquick"
                                [responsive]="true" height="100px" width=""></p-chart>
                            </td>
                            <td class="second-child">
                              <button class="btn btn-outline-success btn-details my-1 my-sm-0" type="submit"
                                (click)="getTranshipmentVoyage(quickdet.vesselsId,quickdet.toVesselsId,quickdet.midPortId,quickdet.fromPortDepartureDate,quickdet.toPortArrivalDate)">DETAILS</button>
                            </td>
                          </tr>
                          <tr *ngIf="quickdet.isTranshipment == 0">
                            <td tooltipPosition="top"
                              pTooltip="Vessel: {{quickdet.vesselsName}} &#xA; Dep.: {{quickdet.fromPortName}} &#xA; Dep. Date: {{quickdet.fromPortDepartureDate}} &#xA; Arr.: {{quickdet.toPortName}} &#xA; Arr. Date: {{quickdet.toPortArrivalDate}}">
                              <img src="{{quickdet.LogoUrl}}" class="image1">
                            </td>
                            <td>
                              <p-chart type="horizontalBar" [data]="quickdet.quickestdata" [options]="optionsquick"
                                [responsive]="true" height="100px" width=""></p-chart>
                            </td>
                            <td class="second-child">
                              <button class="btn btn-outline-success btn-details my-1 my-sm-0" type="submit"
                                (click)="getDetails(quickdet.vesselsId,quickdet.fromPortDepartureDate,quickdet.toPortArrivalDate)">DETAILS</button>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                      <div *ngIf="totalCount == 0">
                        <span>No records found</span>
                      </div>
                    </div>
                    <p-paginator *ngIf="totalCount > 0" [rows]="pageSize" [rowsPerPageOptions]="[5,10,20]"
                      [totalRecords]="totalCount" (onPageChange)="paginatechepest($event)" #p></p-paginator>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>